export const checkTags = (noticeTags, tags) => {
  if (!noticeTags) {
    return true;
  }
  return noticeTags.map(tag => typeof tag === 'string' ? tags.includes(tag) : tag.every(subTag => tags.includes(subTag))).some(condition => Boolean(condition));
};